/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as RequestBodyTypes from '../request-bodies/types'
import * as ResponseTypes from '../responses/types'
import * as SchemaTypes from '../schema/types'
import * as UserTypes from '../users/types'
import * as UtilityTypes from '../utilities/types'

import * as SecurityTypes from './types'

export type ExchangeTokenCreateKey = ['auth', 'exchange-token', unknown]

export type ExchangeTokenCreateResponse = ResponseTypes.TemporaryTokenResponse

export type ExchangeTokenCreateVariables = {
  body?: RequestBodyTypes.ExchangeTokenPost
  query?: void
}

export const exchangeTokenCreate = makeData<
  ExchangeTokenCreateResponse,
  ExchangeTokenCreateKey,
  ExchangeTokenCreateVariables
>({
  method: 'post',
  name: 'exchangeTokenCreate',
  summary: 'Takes a user ID and returns a temporary token that can be exchanged for a real auth token.',
  path: '/auth/exchange-token',
  queryKey: ({ query }) => ['auth', 'exchange-token', query],
})

export type SendOneTimeCodeKey = ['companies', string | undefined, 'auth', 'send-one-time-code', unknown]

export type SendOneTimeCodeResponse = void

export type SendOneTimeCodeVariables = {
  companyId: string | undefined
  body?: {
    /**
     * Either an email address or phone number.
     *
     * If the specified `channel` is `text` or `voice`, or the auth type for the specified
     * `userType` is `oneTimeCodeText`, then this must be a valid phone number. Otherwise,
     * it must be a valid email address.
     *
     * This `username` is used to look up the user in the system.
     *
     * For agents:
     * - If the user belongs to an agent, then the given `username` is used directly as the
     *   recipient email address or phone number to text or call with the one time code.
     *
     * For borrowers:
     * - If the user belongs to a borrower of type `business`, then the given `username`
     *   is used directly as the recipient email address or phone number to text or call
     *   with the one time code.
     * - If the user belongs to a borrower of type `person`, then borrower's primary
     *   contact with `affiliation=self` is selected. And that value is
     *   used as the recipient email address or phone number to text or call with
     *   the one time code.
     */
    username: string
    userType?: SchemaTypes.UserType
    channel: SecurityTypes.OneTimeCodeChannel
    /**
     * Template specific properties to substitute in the corresponding
     * ConfirmationCode template.
     */
    context?: {}
    /** Force using the auth type of the user and not the company */
    force?: boolean
  }
  query?: void
}

export const sendOneTimeCode = makeData<SendOneTimeCodeResponse, SendOneTimeCodeKey, SendOneTimeCodeVariables>({
  method: 'post',
  name: 'sendOneTimeCode',
  summary: 'Send one time code.',
  path: '/companies/{companyId}/auth/send-one-time-code',
  queryKey: ({ query, companyId }) => ['companies', companyId, 'auth', 'send-one-time-code', query],
})

export type UserAuthReplaceKey = ['users', string | undefined, 'auth', unknown]

export type UserAuthReplaceResponse = UtilityTypes.SingletonResponse & {
  data?: UserTypes.UserAuth
}

export type UserAuthReplaceVariables = {
  userId: string | undefined
  body?: SecurityTypes.NewAuth
  query?: void
}

export const userAuthReplace = makeData<UserAuthReplaceResponse, UserAuthReplaceKey, UserAuthReplaceVariables>({
  method: 'put',
  name: 'userAuthReplace',
  summary: "Replace user's auth based on configured company auth type",
  path: '/users/{userId}/auth',
  queryKey: ({ query, userId }) => ['users', userId, 'auth', query],
})

export type InternalUserAuthReplaceKey = ['companies', string | undefined, 'users', string | undefined, 'auth', unknown]

export type InternalUserAuthReplaceResponse = UtilityTypes.SingletonResponse & {
  data?: UserTypes.UserAuth
}

export type InternalUserAuthReplaceVariables = {
  companyId: string | undefined
  userId: string | undefined
  body?: SecurityTypes.NewAuth
  query?: void
}

export const internalUserAuthReplace = makeData<
  InternalUserAuthReplaceResponse,
  InternalUserAuthReplaceKey,
  InternalUserAuthReplaceVariables
>({
  method: 'put',
  name: 'internalUserAuthReplace',
  summary: "Replace user's auth based on configured company auth type",
  path: '/companies/{companyId}/users/{userId}/auth',
  queryKey: ({ query, companyId, userId }) => ['companies', companyId, 'users', userId, 'auth', query],
})
